import { render, staticRenderFns } from "./ManageNotification.vue?vue&type=template&id=07157ce4&"
import script from "./ManageNotification.vue?vue&type=script&lang=js&"
export * from "./ManageNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports